module.exports = __webpack_public_path__ + "img/image (13).d7a1913c.jpg";